module.exports = __webpack_public_path__ + "img/fries.b86fdec4.svg";